<script>
export default {
  props: {
    message: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      required: true,
    },
    spacing: {
      type: Boolean,
      required: false,
    },
    type: {
      type: String,
      validator: (v) => ['success', 'error'].includes(v),
    },
  },
  computed: {
    styleToastComputed() {
      return {
        '-success': this.type === 'success',
        '-error': !this.type === 'success',
        '-spacing': this.spacing,
      };
    },
  },
};
</script>

<template>
  <transition name="slide-fade">
    <div
      v-if="show"
      class="cxm-Toast"
      :class="[styleToastComputed]"
      v-html="message"
    />
  </transition>
</template>

<style lang="scss" scoped>
.cxm-Toast {
  position: fixed;
  align-items: flex-end;
  flex-wrap: nowrap;
  flex-direction: column;
  display: flex;
  right: 10px;
  top: 10px;
  z-index: 100001;
  background: red;
  padding: var(--track-spacing-bg);
  border-radius: 3px;
  color: var(--track-color-white);

  &.-spacing {
    align-items: flex-start;
    padding: var(--track-spacing-sm) var(--track-spacing-md) var(--track-spacing-sm) var(--track-spacing-md);
    border-radius: 4px;
  }

  &.-success {
    background: var(--track-color-positive-medium);
  }
  &.-error {
    background: var(--track-color-negative-medium);
  }
}

.slide-fade-enter-active {
  transition: all 0.9s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
